// extracted by mini-css-extract-plugin
export default {"wrapper":"Offers_wrapper__Lex4l","container":"Offers_container__BAOky","filters":"Offers_filters__phLMH","objectsList":"Offers_objectsList__Zvh2i"};